export default __webpack_public_path__ + "static/media/Montserrat-ExtraLightItalic.792d93c7.ttf";